// src/slices/navbar/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getNavItems, getNavItemById } from "./thunk";

const initialState = { items: [], item: null, loading: false, error: null, pagination: {} };

const navItemSlice = createSlice({
  name: "navItem",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(getNavItems.pending, (state) => {
        state.loading = true;
      })

      .addCase(getNavItems.fulfilled, (state, action) => {
        state.loading = false;

        state.items = action.payload.data?.data || [];

        state.pagination = action.payload.data?.pagination || {};
      })

      .addCase(getNavItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getNavItemById.fulfilled, (state, action) => {
        state.item = action.payload;
      });
  }
});

export default navItemSlice.reducer;
